import i18n from "@/i18n";

export default [
  { id: "active", name: i18n.t("integrations.temporary_replacement.state.active") },
  { id: "upcoming", name: i18n.t("integrations.temporary_replacement.state.upcoming") },
  { id: "expired", name: i18n.t("integrations.temporary_replacement.state.expired") }
];
